export default "__VITE_ASSET__D1hcxS_5__"